import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

//课程
import show from '../views/show.vue'
import myCenter from '../views/myCenter.vue'
import list from '../views/list.vue'
import reg from '../views/reg.vue'
import rank from '../views/rank.vue'


//学习
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: index,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/reg',
    name: 'reg',
    component: reg,
    meta: {
      title: '登记信息'
    }
  },
  {
    path: '/list',
    name: 'list',
    component: list,
    meta: {
      title: '课程列表'
    }
  },
  {
    path: '/show',
    name: 'show',
    component: show,
    meta: {
      title: '课程'
    }
  },
  {
    path: '/mycenter',
    name: 'mycenter',
    component: myCenter,
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/rank',
    name: 'rank',
    component: rank,
    meta: {
      title: '排行榜'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/fronts/learn/', //配置二级目录  
  routes
})

//解决重复点击相同路由报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//全局前置守卫
router.beforeEach((to, from, next) => { 

  if (to.meta.title) {
      document.title = to.meta.title
  }

  // 判断跳转前的url中是否有platform参数，有且跳转后的链接中没有，则带上该参数值
  const fromPlatform = from.query.platform;
  // 生效的platform值：跳转后链接已有则取跳转后的，否则取跳转前的
  const platform = to.query.platform || fromPlatform;

  // 客户端平台(3纵览/4河北日报)需校验账号标识，微信/H5/电脑端不做此校验
  if (to.path !== "/index" && (platform === '3' || platform === '4')) {
    let accountId = store.state.accountId;
    let uniqueId = store.state.uniqueId;
    if (!accountId || !uniqueId) {
      next({path:'/index?app_control=1101', query: to.query});
      return;
    }
  }

  // 微信端(2)需校验 openid/accessid
  if (to.path !== "/index" && platform === '2') {
    let openid = store.state.openid;
    let accessid = store.state.accessid;
    if (!openid || !accessid) {
      next({path:'/index', query: to.query});
      return;
    }
  }

 // H5端需校验 token
  if (to.path !== "/index" && platform === '5') {

    let token = store.state.token;
    if (!token) {
      next({path:'/index', query: to.query});
      return;
    }
  }

  const needQuery = {};

  if (fromPlatform && !to.query.platform) {
    needQuery.platform = fromPlatform;
  }

  // 当platform为3或4时，判断跳转后的url中是否有app_control参数，没有则增加，值为1101
  if ((platform === '3' || platform === '4') && !to.query.app_control) {
    needQuery.app_control = '1101';
  }

  if (Object.keys(needQuery).length) {
    next({
      ...to,
      query: {
        ...to.query,
        ...needQuery
      }
    }); 
  } else {
    next();
  }

})

export default router
